import { Dispatch } from 'redux';

import { SravniNewsSharedEnumsMaterialType, SravniNewsSharedEnumsPlacementType } from '../__generated__/news/Api';
import { TAKE_MATERIALS_INITIAL, TAKE_NEWS_INITIAL } from '../constants/news';
import { TRubricType } from '../interfaces/news';
import { fetchFirstBatchForMaterialsList } from '../reducers/news';
import { formatForRequest } from '../server/utils/formatForRequest';
import { checkIsExcludedRubric } from '../utils/news';

export const loadMaterials = (rubricType?: TRubricType, tagType?: string, organizationId?: string, take?: number) => (
  dispatch: Dispatch<any>,
) => {
  const isNews = Boolean(organizationId) || ['novosti', 'novosti-partnerov', 'novosti-sporta'].includes(rubricType);
  const isExcludedRubric = checkIsExcludedRubric(rubricType);

  let type = SravniNewsSharedEnumsMaterialType.Article;

  if (isExcludedRubric) {
    type = SravniNewsSharedEnumsMaterialType.PrivateArticle;
  } else if (isNews) {
    type = SravniNewsSharedEnumsMaterialType.News;
  }
  return dispatch(
    fetchFirstBatchForMaterialsList({
      DateFrom: formatForRequest(new Date()),
      Placement: isNews ? SravniNewsSharedEnumsPlacementType.NewsList : SravniNewsSharedEnumsPlacementType.ArticlesList,
      Take: take || isNews ? TAKE_NEWS_INITIAL : TAKE_MATERIALS_INITIAL,
      Skip: 0,
      PageIndex: 0,
      type,
      ...(rubricType && { Rubrics: [rubricType] }),
      ...(tagType && { Tags: [tagType] }),
      ...(organizationId && { organizationId }),
    }),
  );
};
